'use client';

import { Popover } from '@base-ui/react/popover';
import { css } from '@repo/pandacss/styled-system/css';
import { useMemo } from 'react';
import { MdHelpOutline } from 'react-icons/md';
import { DisclosureTooltip } from '../../DisclosureTooltip';
import { summaryTableHeadingTooltipClassName } from '../../disclosureTooltipPopover';

export function HeadingTooltip({ label, tooltip }: { label?: string; tooltip: string }) {
  const handler = useMemo(() => Popover.createHandle<unknown>(), []);

  return (
    <span
      className={css({
        display: 'inline',
        whiteSpace: 'nowrap',
      })}
    >
      &nbsp;
      <Popover.Trigger
        handle={handler}
        className={css({
          borderTopStyle: 'none',
          borderRightStyle: 'none',
          borderBottomStyle: 'none',
          borderLeftStyle: 'none',
          backgroundColor: 'transparent',
          paddingTop: '0',
          paddingRight: '0',
          paddingBottom: '0',
          paddingLeft: '0',
          cursor: 'pointer',
          display: 'inline-flex',
          color: 'neutral.black',
          textStyle: 'textSmall',
        })}
        aria-label={label ?? 'info'}
      >
        <MdHelpOutline />
      </Popover.Trigger>
      <DisclosureTooltip handler={handler} tooltipClassName={summaryTableHeadingTooltipClassName}>
        <span
          className={css({
            display: 'block',
            marginTop: '0',
            marginRight: '0',
            marginBottom: '0',
            marginLeft: '0',
            textAlign: 'left',
            fontFamily: 'gotham',
            fontSize: '[0.813rem]',
            fontWeight: 'normal',
            lineHeight: {
              base: 'xxxxxl',
              md: 'xl',
            },
            wordWrap: 'break-word',
          })}
        >
          {tooltip}
        </span>
      </DisclosureTooltip>
    </span>
  );
}
